import * as angular from "angular";
import * as moment from "moment";
import {SiteContextService} from "../../commons/services/site-context.service";
import {SplitService} from "../../commons/services/split-service.service";
import {VisitPlanDatasourceEnum} from "../enums/visit-plan-datasource.enum";
import {PricePlanBundleRequestsService} from "../../price-plan/services/price-plan-bundle-requests.service";
import {CallStopPurposeEnum} from "../enums/call-stop-purpose.enum";
import * as _ from "lodash";
import {filter, get, isUndefined} from "lodash";
import {OrdersService} from "../../orders/services/orders-service.service";
import {VisitScheduleDayModel} from "../models/visit-schedule-day.model";
import {VisitPlanModel} from "../models/visit-plan.model";
import {VisitScheduleModel} from "../models/visit-schedule.model";
import {VisitScheduleFacadeService} from "../angular/services/visit-schedule-facade.service";
import {VisitScheduleStatusEnum} from "../enums/visit-schedule-status.enum";
import {VisitPlanFacadeService} from "../angular/services/visit-plan-facade.service";
import {VisitPlanStatusEnum} from "../enums/visit-plan-status.enum";
import {
  ConsiderVehicleLocation,
  ConstraintConfigurationModel, ConstraintConfigurationsModel,
  VisitScheduleOptimizationSettings
} from "../models/visit-schedule-optimization-config.model";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";
import {VisitPlanHttpService} from "../angular/services/visit-plan-http.service";
import {ProcessTrackingStatusEnum} from "../../commons/types/process-tracking-status.enum";
import {ProcessTrackingTypeEnum} from "../../commons/types/process-tracking-type.enum";
import {ProcessTrackingMeasurementTypeEnum} from "../../commons/types/process-tracking-measurement-type.enum";
import {
  AccountsImportBatchModel,
  AccountsImportValidateRowModel,
  AgentsImportBatchModel,
  AgentsImportBatchStatusEnum,
  AgentsImportStatusModel,
  AgentsImportValidateRowModel,
  SchedulingProjectProviderType,
  SchedulingProjectVisitCallProviderType,
  VisitPlanAccountImportMode,
  VisitPlanAgentImportMode
} from "../models/visit-plan-imports.model";
import {AccountModel} from "../../account/angular/models/account.model";
import {AccountPreferredAgent} from "../../account/models/account-preferred-agent.model";
import {finalize} from "rxjs";
import {
  VisitPlanScheduleRouteReassignmentComponent
} from "../angular/components/visit-plan-schedule-route-reassignment/visit-plan-schedule-route-reassignment.component";
import {
  VisitScheduleAgentImportDialogComponent
} from "../angular/components/visit-schedule-agent-import-dialog/visit-schedule-agent-import-dialog.component";
import {PanelService} from "../../commons/angular/services/panel.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {SchedulingProjectAlertsService} from "./scheduling-project-alerts.service";
import {SCHEDULING_PROJECT_TEMPLATE_SOFT_CONSTRAINTS_MAP, visitPlanAccountsImportSampleFileLink, visitPlanAccountsImportSampleFileName, visitScheduleAgentsImportSampleFileLink, visitScheduleAgentsImportSampleFileName} from "../angular/constants/scheduling-project.constant";
import {PlanningServerEnum} from "../enums/planning-server.enum";
import {VisitScheduleResourceSettingsModel} from "../models/visit-schedule-resource-settings.model";
import {IAMPermissionsService} from "../../../permission/iamPermissions.service";
import {SchedulingProjectTemplateFilterService} from "./scheduling-project-template-filter.service";
import {PollingIntervalRef, PollingIntervalService} from "../../commons/services/polling-interval.service";
import {ProcessTrackingModel} from "../../commons/models/process-tracking.model";
import {BatchTypeEnum} from "../../batch/enums/batch-type.enum";
import {RecoveryActionEnum} from "../../batch/enums/recovery-action.enum";
import {BatchRecoveryService} from "../../batch/services/batch-recovery.service";
import {BatchProcessTrackingModel} from "../../batch/models/batch-process-tracking.model";
import {VisitPlanProcessingDialogResultModel} from "../models/visit-plan-processing-dialog-result.model";
import {SiteProvidersService} from "../../site-preferences/angular/services/site-providers.service";
import {SiteProviderModel} from "../../site-preferences/angular/models/site-provider.model";
import {
  buildTemplateProviderIds,
  buildTemplateProviderOptions,
  resolveTemplateProviderSelection
} from "../models/scheduling-project-template-providers.functions";

export class SchedulingProjectDialogService {

  private readonly VISIBLE_SOFT_CONSTRAINTS_KEYS: string[] = SCHEDULING_PROJECT_TEMPLATE_SOFT_CONSTRAINTS_MAP.map(constraint => constraint.key);
  private PULLING_INTERVAL: number = 5000;

  /* @ngInject */
  constructor(private $mdDialog, private siteContextService: SiteContextService,
              private splitService: SplitService, private moment, private pricePlanBundleRequestsService: PricePlanBundleRequestsService,
              private ordersService: OrdersService, private visitScheduleFacadeService: VisitScheduleFacadeService,
              private schedulingProjectAlertsService: SchedulingProjectAlertsService, private IAMPermissions: IAMPermissionsService,
              private visitPlanFacadeService: VisitPlanFacadeService, private bringozToastService: BringozToastService,
              private visitPlanHttpService: VisitPlanHttpService, private commonsConstants,
              private schedulingProjectTemplateFilterService: SchedulingProjectTemplateFilterService,
              private siteProvidersService: SiteProvidersService) {
  }

  createVisitPlan(event?, sourceVisitPlan?: VisitPlanModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-visit-plan-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, UserService, $filter, $timeout, $groups) {

        $scope.isDuplicate = !!sourceVisitPlan;
        $scope.sourceVisitPlan = sourceVisitPlan;

        const currentUser = UserService.getCurrentUser();

        $scope._getDefaultName = () => {
          // const groupName = $scope.groups?.length ? $scope.groups[0].name : '';
          let groupBranchName = undefined;

          if ($scope.branches?.length === 1) {
            groupBranchName = $scope.branches[0].name;
          } else if ($scope.groups?.length === 1) {
            groupBranchName = $scope.groups[0].name;
          } else if ((!$scope.groups?.length || $scope.groups?.length > 1) && $scope.branches?.length === 1) {
            groupBranchName = $scope.branches[0].name;
          } else if ($scope.groups?.length > 1) {
            groupBranchName = $filter('translate')('Multiple Groups');
          } else if ($scope.branches?.length > 1) {
            groupBranchName = $filter('translate')('Multiple Branches');
          }

          return `${groupBranchName ? groupBranchName + ' ' : ''}${$filter('bringozDateRange')({from: $scope.scheduleProject.from, to: $scope.scheduleProject.to})} - ${currentUser.displayName}`;
        }

        $scope.userTimeZone = self.splitService.getTimeZone();
        $scope.selectedTimeZone = self.splitService.getTimeZone();

        $scope.scheduleProject = {
          name: undefined,
          from: self.moment().tz($scope.selectedTimeZone).startOf('day').valueOf(),
          to: self.moment().tz($scope.selectedTimeZone).add(6, 'day').endOf('day').valueOf(),
          branchIds: [],
          isPublic: true,
          schedulingProjectTemplateId: undefined,
          visitPlanConfig: {
            visitSlotProviderTypeRegistry: {
              visitSlotServiceTimeProviderType: [],
              visitSlotUnitsProviderType: [],
              visitSlotDeliveryTimeProviderType: []
            }
          }
        }

        // Load templates
        $scope.selectedTemplateId = undefined;
        $scope.selectedTemplate = undefined;
        $scope.showTemplates = false;
        $scope.templatesList = [];
        $scope.templateIds = [];
        $scope.templatesWrapper = undefined;

        const applyVisibleTemplates = (templates, groupBranchIdsMap?) => {
          const visibleTemplates = self.schedulingProjectTemplateFilterService.filterTemplatesForUser(
            templates,
            self._getCurrentUserTemplateScope(groupBranchIdsMap)
          );

          $scope.templatesList = visibleTemplates;
          $scope.templateIds = visibleTemplates.map(t => t.id);
          $scope.templatesWrapper = {
            list: visibleTemplates,
            propertyRef: 'name'
          };
          $scope.showTemplates = true;

          if ($scope.selectedTemplateId && !visibleTemplates.some(t => t.id === $scope.selectedTemplateId)) {
            $scope.selectedTemplateId = undefined;
            $scope.selectedTemplate = undefined;
            $scope.scheduleProject.schedulingProjectTemplateId = undefined;
          }
        };

        if (self.visitPlanHttpService && self.visitPlanHttpService.getAllTemplates) {
          const userBranchIds = self.splitService.getUserSiteBranchIds() || [];
          self.visitPlanHttpService.getAllTemplates(100, userBranchIds.length ? userBranchIds : undefined).subscribe({
            next: (response) => {
              const templates = response.list || [];
              const groupIds = self.schedulingProjectTemplateFilterService.collectTemplateGroupIds(templates);

              if (!groupIds.length) {
                applyVisibleTemplates(templates);
                return;
              }

              $groups().$asyncValues(groupIds)
                .then((groups) => {
                  applyVisibleTemplates(
                    templates,
                    self.schedulingProjectTemplateFilterService.buildGroupBranchIdsMap(groups)
                  );
                })
                .catch((err) => {
                  console.error('Failed to resolve template group branches', err);
                  applyVisibleTemplates(templates);
                });
            },
            error: (err) => {
              console.error('Failed to load templates', err);
            }
          });
        } else {
          console.error('visitPlanHttpService is not available!');
        }

        // Init custom name
        $scope.isDefaultName = true;
        $scope.scheduleProject.name = $scope._getDefaultName();

        $scope.groupIds = [];
        $scope.branches = [];
        $scope.groupsBranchIds = undefined;
        $scope.schedulingProjectConfigurations = self.splitService.getVisitPlanProviders();

        // Helper function to set provider with preferred default or fallback to first available
        const setProviderWithDefault = (providerType, preferredValue, availableProviders) => {
          if (!availableProviders || !availableProviders.length) {
            return;
          }

          // Check if preferred value exists in available providers
          const providerValue = availableProviders.includes(preferredValue)
            ? preferredValue
            : availableProviders[0];

          $scope.scheduleProject.visitPlanConfig.visitSlotProviderTypeRegistry[providerType].push(providerValue);
        };

        // Set default providers (will be overridden if template is selected)
        setProviderWithDefault(
          'visitSlotServiceTimeProviderType',
          'MDLZ_PROJECTION_WEIGHTED',
          $scope.schedulingProjectConfigurations?.visitSlotServiceTimeProviders
        );

        setProviderWithDefault(
          'visitSlotUnitsProviderType',
          'MDLZ_PROJECTION_WEIGHTED',
          $scope.schedulingProjectConfigurations?.visitSlotUnitsProviders
        );

        setProviderWithDefault(
          'visitSlotDeliveryTimeProviderType',
          'MDLZ_PREDICTION',
          $scope.schedulingProjectConfigurations?.visitSlotDeliveryTimeProviders
        );

        $scope.maximumToDate = self.moment.tz($scope.scheduleProject.from, $scope.selectedTimeZone).add(6, 'days').endOf('day').valueOf();

        // Pre-fill form from a source visit plan (Duplicate flow)
        if (sourceVisitPlan) {
          const sourceZoneId = sourceVisitPlan.zoneId || self.siteContextService.getSiteInfo().zoneId;
          $scope.selectedTimeZone = sourceZoneId;
          self.moment.tz.setDefault($scope.selectedTimeZone);

          const sourceDuration = Math.max(0, (sourceVisitPlan.to || 0) - (sourceVisitPlan.from || 0));
          const newFrom = self.moment.tz($scope.selectedTimeZone).startOf('day').valueOf();
          const newTo = sourceDuration > 0
            ? self.moment.tz(newFrom, $scope.selectedTimeZone).add(sourceDuration, 'milliseconds').valueOf()
            : self.moment.tz(newFrom, $scope.selectedTimeZone).add(6, 'days').endOf('day').valueOf();

          $scope.scheduleProject = {
            ...$scope.scheduleProject,
            name: `${sourceVisitPlan.name || ''} - ${$filter('translate')('Copy')}`,
            description: sourceVisitPlan.description,
            from: newFrom,
            to: newTo,
            branchIds: [...(sourceVisitPlan.branchIds || [])],
            isPublic: sourceVisitPlan.isPublic ?? true,
            schedulingProjectTemplateId: sourceVisitPlan.schedulingProjectTemplateId,
            visitPlanConfig: angular.copy(sourceVisitPlan.visitPlanConfig) || $scope.scheduleProject.visitPlanConfig
          };

          $scope.groupIds = (sourceVisitPlan.groupReferences || []).map(g => g.id);

          const template = $scope.templatesList.find(t => t.id === sourceVisitPlan.schedulingProjectTemplateId);

          $scope.selectedTemplateId = sourceVisitPlan.schedulingProjectTemplateId;
          $scope.selectedTemplate = template;
          $scope.maximumToDate = self.moment.tz(newFrom, $scope.selectedTimeZone).add(6, 'days').endOf('day').valueOf();
          $scope.isDefaultName = false;
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.onNameChange = (name) => {
          $scope.isDefaultName = !name;
          $scope.scheduleProject.name = name || $scope._getDefaultName();
        }

        $scope.switchTimeZone = (zoneId) => {
          const prevZone = $scope.selectedTimeZone;
          $scope.selectedTimeZone = zoneId;
          // this.moment.tz.setDefault($scope.selectedTimeZone);

          if ($scope.scheduleProject.from) {
            const dateString = self.moment.tz($scope.scheduleProject.from, prevZone).format('YYYY-MM-DD');
            $scope.scheduleProject.from = self.moment.tz(dateString, 'YYYY-MM-DD', $scope.selectedTimeZone).startOf('day').valueOf();
          }
          if ($scope.scheduleProject.to) {
            const dateString = self.moment.tz($scope.scheduleProject.to, prevZone).format('YYYY-MM-DD');
            $scope.scheduleProject.to = self.moment.tz(dateString, 'YYYY-MM-DD', $scope.selectedTimeZone).endOf('day').valueOf();
          }
          if ($scope.maximumToDate) {
            const dateString = self.moment.tz($scope.maximumToDate, prevZone).format('YYYY-MM-DD');
            $scope.maximumToDate = self.moment.tz(dateString, 'YYYY-MM-DD', $scope.selectedTimeZone).endOf('day').valueOf();
          }

          if ($scope.isDefaultName) {
            $scope.scheduleProject.name = $scope._getDefaultName();
          }
        }

        $scope.onFromDateChange = (date) => {
          const localMoment = self.moment(date);
          const dateString = localMoment.format('YYYY-MM-DD');
          const from = self.moment.tz(dateString, 'YYYY-MM-DD', $scope.selectedTimeZone).startOf('day').valueOf();
          $scope.scheduleProject.from = from;

          if (sourceVisitPlan) {
            // Preserve the original project's duration on duplicate
            const duration = Math.max(0, (sourceVisitPlan.to || 0) - (sourceVisitPlan.from || 0));
            $scope.scheduleProject.to = duration > 0
              ? self.moment.tz(from, $scope.selectedTimeZone).add(duration, 'milliseconds').valueOf()
              : self.moment.tz(from, $scope.selectedTimeZone).add(6, 'days').endOf('day').valueOf();
          } else {
            $scope.scheduleProject.to = self.moment.tz(from, $scope.selectedTimeZone).add(6, 'days').endOf('day').valueOf();
          }

          $scope.maximumToDate = self.moment.tz(from, $scope.selectedTimeZone).add(6, 'days').endOf('day').valueOf();

          if ($scope.isDefaultName) {
            $scope.scheduleProject.name = $scope._getDefaultName();
          }
        }

        $scope.onToDateChange = (date) => {
          const localMoment = self.moment(date);
          const dateString = localMoment.format('YYYY-MM-DD');
          $scope.scheduleProject.to = self.moment.tz(dateString, 'YYYY-MM-DD', $scope.selectedTimeZone).endOf('day').valueOf();

          if ($scope.isDefaultName) {
            $scope.scheduleProject.name = $scope._getDefaultName();
          }
        }

        $scope.onGroupsSelect = (groups, selectedIds) => {
          $scope.groups = groups;
          $scope.groupIds = selectedIds;
          $scope.groupsBranchIds = !!groups?.length ? _.uniq(_.flatMap(groups, 'branchIds')) : undefined;

          if ($scope.isDefaultName) {
            $scope.scheduleProject.name = $scope._getDefaultName();
          }
        }

        $scope.onBranchesSelect = (branches, branchIds) => {
          $scope.branches = branches;
          $scope.scheduleProject.branchIds = branchIds;

          if ($scope.isDefaultName) {
            $scope.scheduleProject.name = $scope._getDefaultName();
          }
        }

        $scope.onSelectTemplate = (templateId) => {
          // templateId is the template ID (string), look up the full template object
          const template = $scope.templatesList.find(t => t.id === templateId);
          $scope.selectedTemplateId = templateId;
          $scope.selectedTemplate = template;
          $scope.scheduleProject.schedulingProjectTemplateId = template?.id;

          // Clear existing providers
          $scope.scheduleProject.visitPlanConfig.visitSlotProviderTypeRegistry = {
            visitSlotServiceTimeProviderType: [],
            visitSlotUnitsProviderType: [],
            visitSlotDeliveryTimeProviderType: []
          };

          // If template has visitSlotProviderTypeRegistry with providers, use them
          if (template?.visitSlotProviderTypeRegistry) {
            const templateProviders = template.visitSlotProviderTypeRegistry;

            // Set providers from template
            if (templateProviders.visitSlotServiceTimeProviderType?.length) {
              $scope.scheduleProject.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotServiceTimeProviderType =
                [...templateProviders.visitSlotServiceTimeProviderType];
            }

            if (templateProviders.visitSlotUnitsProviderType?.length) {
              $scope.scheduleProject.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotUnitsProviderType =
                [...templateProviders.visitSlotUnitsProviderType];
            }

            if (templateProviders.visitSlotDeliveryTimeProviderType?.length) {
              $scope.scheduleProject.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotDeliveryTimeProviderType =
                [...templateProviders.visitSlotDeliveryTimeProviderType];
            }
          } else {
            // No template selected or template has no providers - use defaults
            setProviderWithDefault(
              'visitSlotServiceTimeProviderType',
              'MDLZ_PROJECTION_WEIGHTED',
              $scope.schedulingProjectConfigurations?.visitSlotServiceTimeProviders
            );

            setProviderWithDefault(
              'visitSlotUnitsProviderType',
              'MDLZ_PROJECTION_WEIGHTED',
              $scope.schedulingProjectConfigurations?.visitSlotUnitsProviders
            );

            setProviderWithDefault(
              'visitSlotDeliveryTimeProviderType',
              'MDLZ_PREDICTION',
              $scope.schedulingProjectConfigurations?.visitSlotDeliveryTimeProviders
            );
          }

          if ($scope.selectedTemplate?.schedulingProjectRules?.allowedStartDays) {
            $scope.allowedStartDays = $scope.selectedTemplate.schedulingProjectRules.allowedStartDays.reduce((acc: number[], day: number | string) => {
              const index: number = self.commonsConstants.dayArray.indexOf(day);

              if (index >= 0) {
                acc.push(index);
              }

              return acc;
            }, []);
          }

          if ($scope.selectedTemplate?.schedulingProjectRules?.allowedEndDays) {
            $scope.allowedEndDays = $scope.selectedTemplate.schedulingProjectRules.allowedEndDays.reduce((acc: number[], day: number | string) => {
              const index: number = self.commonsConstants.dayArray.indexOf(day);

              if (index >= 0) {
                acc.push(index);
              }

              return acc;
            }, []);
          }

          $scope.refreshDateFilters();
        }

        $scope.refreshDateFilters = () => {
          // to refresh the md-date-picker predicates we need to change the reference of the predicate
          $scope.isStartDaysValid = (d: Date | null): boolean => {
            if (!d || !$scope.allowedStartDays) {
              return true;
            }

            const day = d.getDay();

            return $scope.allowedStartDays?.includes(day);
          };

          $scope.isEndDaysValid = (d: Date | null): boolean => {
            if (!d || !$scope.allowedEndDays) {
              return true;
            }

            const day = d.getDay();

            return $scope.allowedEndDays.includes(day);
          };
        };

        $scope.refreshDateFilters();

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.selectedTimeZone = $scope.selectedTimeZone ? $scope.selectedTimeZone : self.splitService.getTimeZone()
              self.$mdDialog.hide({...$scope.scheduleProject, zoneId: $scope.selectedTimeZone});
            }

          }
        }

      }
    })
  }

  createVisitPlanCall(serviceType, date, account, visitPlan, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-visit-plan-call-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        const programTypeAliasMap = self.splitService.getProgramCodesMap();

        $scope.serviceType = serviceType;
        $scope.call = {
          serviceType: serviceType,
          programType: {
            initial: {
              value: undefined,
              source: VisitPlanDatasourceEnum.Manual
            }
          },
          skills: {
            initial: {
              value: [],
              source: VisitPlanDatasourceEnum.Manual
            }
          },
          source: VisitPlanDatasourceEnum.Manual,
          // units: {
          //   initial: {
          //     value: 0,
          //     source: VisitPlanDatasourceEnum.Manual
          //   }
          // },
          destination: {
            purpose: CallStopPurposeEnum.Operation,
            serviceTime: {
              initial: {
                value: undefined,
                source: VisitPlanDatasourceEnum.Manual
              }
            },
            notBefore: {
              initial: {
                value: self.moment.tz(date, visitPlan.zoneId).startOf('day').valueOf(),
                source: VisitPlanDatasourceEnum.Manual
              }
            },
            notAfter: {
              initial: {
                value: self.moment.tz(date, visitPlan.zoneId).endOf('day').valueOf(),
                source: VisitPlanDatasourceEnum.Manual
              }
            },
            subtasks: {
              initial: {
                value: [],
                source: VisitPlanDatasourceEnum.Manual
              }
            }
          }
        }

        $scope.callType = programTypeAliasMap[$scope.call.programType.initial.value];
        $scope.isOrderOrSell = $scope.callType === 'O' || $scope.callType === 'S';

        $scope.allowedRecurringTypes = ['DAILY', 'WEEKLY', 'MONTHLY'];
        $scope.recurringType = undefined;
        $scope.recurrence = {
          repeatInterval: undefined
        };
        $scope.isPermanent = false;
        $scope.selectedDayOfWeek = self.moment.tz(date, visitPlan.zoneId).format('dd');
        $scope.isEnding = false;
        $scope.endRecurring = undefined;

        // $scope.subtasks = [];

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              // $scope.subtasks.forEach(st => {
              //   const subtaskFieldValue = {
              //     initial: {
              //       value: st,
              //       source: VisitPlanDatasourceEnum.Manual
              //     }
              //   }
              //   $scope.call.destination.subtasks.push(subtaskFieldValue);
              // })

              let recurrencePattern;

              if ($scope.recurringType) {
                recurrencePattern = {
                  permanent: !!$scope.isPermanent,
                  repeatFreq: $scope.recurringType.type,
                  repeatInterval: $scope.recurrence.repeatInterval || 1,
                  endRecurring: $scope.isEnding ? $scope.endRecurring : undefined
                };

                if ($scope.recurringType.type === 'WEEKLY') {
                  recurrencePattern.dayOfWeek = $scope.selectedDayOfWeek;
                }
              }

              self.$mdDialog.hide({
                call: $scope.call,
                recurrencePattern: recurrencePattern
              });
            }
          }
        }

        $scope.onChangePricePlan = (pricePlan) => {
          $scope.call.programType.initial.value = pricePlan;
          $scope.callType = programTypeAliasMap[$scope.call.programType.initial.value];
          $scope.isOrderOrSell = $scope.callType === 'O' || $scope.callType === 'S';
          $scope._loadOrderSettings(pricePlan);
        }

        $scope.onChangeDetailedTimeValue = (type, serviceTime) => {
          $scope.call.destination.serviceTime.initial.value[type] = serviceTime;
        }

        $scope.onRangeChange = (from, to) => {
          $scope.call.destination.notBefore.initial.value = from;
          $scope.call.destination.notAfter.initial.value = to;
        }

        $scope.onChangeIsPermanent = () => {
          $scope.isPermanent = !$scope.isPermanent;

          if ($scope.isPermanent) {
            $scope.recurringType = self.commonsConstants.rruleTypes.find(rruleType => rruleType.type === 'WEEKLY');
            $scope.recurrence.repeatInterval = 1;
          } else {
            $scope.recurringType = undefined;
            $scope.recurrence.repeatInterval = undefined;
            $scope.isEnding = false;
            $scope.endRecurring = undefined;
          }
        }

        $scope.onRecurringChange = (type) => {
          const wasRecurring = !!$scope.recurringType;
          $scope.recurringType = type;

          if (!type) {
            $scope.isPermanent = false;
            $scope.recurrence.repeatInterval = undefined;
            $scope.isEnding = false;
            $scope.endRecurring = undefined;
          } else if (!wasRecurring) {
            $scope.isPermanent = true;
            $scope.recurrence.repeatInterval = 1;
          }
        }

        $scope.onDayOfWeekChange = (dayKey) => {
          $scope.selectedDayOfWeek = dayKey;
        }

        $scope.onChangeIsEnding = () => {
          $scope.isEnding = !$scope.isEnding;
          $scope.endRecurring = undefined;
        }

        $scope.onEndRecurringChange = (date) => {
          $scope.endRecurring = date ? self.moment(date).endOf('day').valueOf() : undefined;
        }

        $scope.onSubTasksChanged = (subtasks) => {
          $scope.call.destination.subtasks.initial.value = subtasks;
        }

        $scope.onAddSubTaskToTask = (subtask) => {
          $scope.call.destination.subtasks.initial.value.push(subtask);
        }

        $scope.onRemoveSubtask = (subtask, index) => {
          $scope.call.destination.subtasks.initial.value.splice(index, 1);
        }

        $scope._loadOrderSettings = (selectedPricePlanType) => {

          const quoteTypes = ['TimeSlot', 'PerTask'];
          self.ordersService.getOrderSettings(account.id, serviceType, selectedPricePlanType, quoteTypes, undefined, undefined, visitPlan.from, visitPlan.zoneId)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.availableDays = _.get(serviceRef, 'availableDays', []);

              const workingHourDate = orderSettings.workingHours[self.moment.tz(date, visitPlan.zoneId).startOf('day').valueOf()];

              if (!!workingHourDate) {
                $scope.call.destination.notBefore.initial.value = workingHourDate.from;
                $scope.call.destination.notAfter.initial.value = workingHourDate.to;
                // $scope.call.destination.notAfter.initial.value = this.moment(workingHourDate.to).subtract(1, 'minute').valueOf();
              }

              $scope.call.skills.initial.value = _.get(serviceRef, 'defaultSkills');

              // const today = _.find($scope.availableDays, (d) => {
              //   return this.moment().isSame(this.moment(d), 'day');
              // });

              // if (!!today) {
              // }


              // $scope.selectedDate = $scope.availableDays.length ? this.moment(today || _.head($scope.availableDays)).toDate() : undefined;

              $scope.subTaskOptionsMap = {
                [CallStopPurposeEnum.Pickup]: [],
                [CallStopPurposeEnum.Dropoff]: [],
                [CallStopPurposeEnum.Operation]: []
              }

              serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Pickup)) {
                  $scope.subTaskOptionsMap.Pickup.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Dropoff)) {
                  $scope.subTaskOptionsMap.Dropoff.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Operation)) {
                  $scope.subTaskOptionsMap.Operation.push(optionalSubTask);
                }
              })

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;

              // $scope.call.destination.subtasks.initial.value = _.filter(serviceRef.defaultSubTasks, (defaultSubTask) => {
              //   return defaultSubTask.purposes.includes($scope.call.destination.purpose)
              // });

              serviceRef.defaultSubTasks.forEach(defaultSubTask => {
                $scope.subtasks.push(defaultSubTask);
              })

              // $scope.call.destination.subtasks.initial.value.forEach(st => {
              //   st.actions = $scope._getSubTaskActionsWithDefaults(st);
              // })

              if ($scope.call.destination.purpose === CallStopPurposeEnum.Operation) {
                $scope.call.destination.serviceTime.initial.value = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime', {});
                $scope.currentEditCallMinSerivceTime = (($scope.call.destination.serviceTime.generatedTotalTime || 0) - ($scope.call.destination.serviceTime.workTime || 0)) / 60000;
              }

            })
        }

        if (account) {
          $scope.account = account;
          $scope.loading = true;
          return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id)
            .then((pricePlanBundle) => {
              $scope.programTypes = filter(pricePlanBundle.entryList, (e) => {
                return e.enabled && e.name !== "Delivery";
              });

              return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType(account.id, $scope.serviceType);
            })
            .then((defaultPricePlanTypeByServiceType) => {
              $scope.call.programType.initial.value = get(defaultPricePlanTypeByServiceType, 'pricePlanType');

              if ($scope.call.programType.initial.value) {
                $scope._loadOrderSettings($scope.call.programType.initial.value);
              }
            })
            .catch((error) => {
            })
            .finally(() => {
              $scope.loading = false;
            })
        }


      }
    })
  }

  editVisitPlanCall(call, callType, visitPlan, account?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/edit-visit-plan-call-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, UUIDService) {

        $scope.serviceType = call.serviceType;
        $scope.callCopy = angular.copy(call);
        $scope.isOrderOrSell = callType === 'O' || callType === 'S';

        $scope.getFieldValue = (field) => {
          if (!field) {
            return undefined;
          } else if (!field.adjusted?.value) {
            return field.initial?.value
          } else {
            return field.adjusted?.value
          }
        }

        $scope.callModel = {
          units: $scope.getFieldValue($scope.callCopy.units),
          destination: {
            serviceTime: $scope.getFieldValue($scope.callCopy.destination.serviceTime),
            notBefore: $scope.getFieldValue($scope.callCopy.destination.notBefore),
            notAfter: $scope.getFieldValue($scope.callCopy.destination.notAfter),
            subtasks: angular.copy($scope.getFieldValue($scope.callCopy.destination.subtasks)) || []
          },
          skills: $scope.getFieldValue($scope.callCopy.skills)
        }

        // $scope.callCopy.destination.subtasks?.forEach(st => {
        //   const subTaskValue = $scope.getFieldValue(st);
        //   $scope.callModel.destination.subtasks.push(subTaskValue);
        // })


        $scope.currentEditCallMinSerivceTime = (($scope.callModel.destination.serviceTime.generatedTotalTime || 0) - ($scope.callModel.destination.serviceTime.workTime || 0)) / 60000;


        $scope.cancel = self.$mdDialog.cancel;

        $scope.primitiveArraysChanged = (arr1, arr2) => {
          if (arr1?.length !== arr2?.length) {
            return true;
          }

          const arr1Set = new Set(arr1);
          const arr2Set = new Set(arr2);

          if (arr1Set.size !== arr2Set.size) {
            return true;
          }

          for (const item of arr1Set) {
            if (!arr2Set.has(item)) {
              return true;
            }
          }

          return false;
        }

        $scope.objectArraysChanged = (arr1, arr2) => {
          if (arr1?.length !== arr2?.length) {
            return true; // added/removed
          }

          const normalize = (obj) => {
            if (obj.id) {
              return `id:${obj.id}`;
            }
            return JSON.stringify(obj);
          };

          const arr1Norm = arr1.map(normalize).sort();
          const arr2Norm = arr2.map(normalize).sort();

          for (let i = 0; i < arr1Norm.length; i++) {
            if (arr1Norm[i] !== arr2Norm[i]) {
              return true;
            }
          }

          return false;
        };

        $scope.onChangeIsPermanent = () => {
          $scope.isPermanent = !$scope.isPermanent;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              // if ($scope.primitiveArraysChanged($scope.getFieldValue($scope.callCopy.skills), $scope.callModel.skills)) {
              //   if (!$scope.callCopy.skills) {
              //     $scope.callCopy.skills = {}
              //   }
              //
              //   if (!$scope.callCopy.skills.adjusted) {
              //     $scope.callCopy.skills.adjusted = {};
              //   }
              //   $scope.callCopy.skills.hasPendingChanges = true;
              //   $scope.callCopy.skills.adjusted.value = $scope.callModel.skills;
              //   $scope.callCopy.skills.adjusted.source = VisitPlanDatasourceEnum.Manual;
              // }

              if ($scope.getFieldValue($scope.callCopy.units) !== $scope.callModel.units) {
                if (!$scope.callCopy.units) {
                  $scope.callCopy.units = {}
                }

                if (!$scope.callCopy.units.adjusted) {
                  $scope.callCopy.units.adjusted = {};
                }
                $scope.callCopy.units.hasPendingChanges = true;
                $scope.callCopy.units.adjusted.value = $scope.callModel.units;
                $scope.callCopy.units.adjusted.source = VisitPlanDatasourceEnum.Manual;
              }

              if ($scope.getFieldValue($scope.callCopy.destination.notBefore) !== $scope.callModel.destination.notBefore) {
                if (!$scope.callCopy.destination.notBefore) {
                  $scope.callCopy.destination.notBefore = {}
                }

                if (!$scope.callCopy.destination.notBefore.adjusted) {
                  $scope.callCopy.destination.notBefore.adjusted = {};
                }
                $scope.callCopy.destination.notBefore.hasPendingChanges = true;
                $scope.callCopy.destination.notBefore.adjusted.value = $scope.callModel.destination.notBefore;
                $scope.callCopy.destination.notBefore.adjusted.source = VisitPlanDatasourceEnum.Manual;
              }

              if ($scope.getFieldValue($scope.callCopy.destination.notAfter) !== $scope.callModel.destination.notAfter) {
                if (!$scope.callCopy.destination.notAfter) {
                  $scope.callCopy.destination.notAfter = {}
                }

                if (!$scope.callCopy.destination.notAfter.adjusted) {
                  $scope.callCopy.destination.notAfter.adjusted = {};
                }
                $scope.callCopy.destination.notAfter.hasPendingChanges = true;
                $scope.callCopy.destination.notAfter.adjusted.value = $scope.callModel.destination.notAfter;
                $scope.callCopy.destination.notAfter.adjusted.source = VisitPlanDatasourceEnum.Manual;
              }

              if ($scope.getFieldValue($scope.callCopy.destination.serviceTime)?.workTime !==
                $scope.callModel.destination.serviceTime.workTime) {

                if (!$scope.callCopy.destination.serviceTime) {
                  $scope.callCopy.destination.serviceTime = {}
                }

                if (!$scope.callCopy.destination.serviceTime?.adjusted) {
                  $scope.callCopy.destination.serviceTime.adjusted = {};
                }

                $scope.callCopy.destination.serviceTime.hasPendingChanges = true;

                $scope.callCopy.destination.serviceTime.adjusted.value =
                  {
                    ...$scope.getFieldValue($scope.callCopy.destination.serviceTime),
                    workTime: $scope.callModel.destination.serviceTime.workTime
                  };
                $scope.callCopy.destination.serviceTime.adjusted.source = VisitPlanDatasourceEnum.Manual;
              }

              if ($scope.objectArraysChanged($scope.getFieldValue($scope.callCopy.destination.subtasks), $scope.callModel.destination.subtasks) || $scope.subtasksHasChagned) {
                if (!$scope.callCopy.destination.subtasks) {
                  $scope.callCopy.destination.subtasks = {}
                }

                if (!$scope.callCopy.destination.subtasks.adjusted) {
                  $scope.callCopy.destination.subtasks.adjusted = {};
                }
                $scope.callCopy.destination.subtasks.hasPendingChanges = true;
                $scope.callCopy.destination.subtasks.adjusted.value = $scope.callModel.destination.subtasks;
                $scope.callCopy.destination.subtasks.adjusted.source = VisitPlanDatasourceEnum.Manual;
              }

              self.$mdDialog.hide({call: $scope.callCopy, isPermanent: $scope.isPermanent});
            }
          }
        }

        $scope.onChangeDetailedTimeValue = (type, serviceTime) => {
          const detailedServiceTimeCopy = angular.copy($scope.callModel.destination.serviceTime);
          detailedServiceTimeCopy[type] = serviceTime;
          $scope.callModel.destination.serviceTime = detailedServiceTimeCopy;
        }

        $scope.onSkillsChange = (ids) => {
          $scope.callModel.skills = ids;
        }

        $scope.onRangeChange = (from, to) => {
          $scope.callModel.destination.notBefore = from;
          $scope.callModel.destination.notAfter = to;
        }

        $scope.onSubTasksChanged = (subtasks) => {
          $scope.callModel.destination.subtasks = subtasks;
          $scope.subtasksHasChagned = true;
        }

        // $scope.onSubTaskChanged = (subtask) => {
        //   const subtaskCopy = {...angular.copy(subtask), hasPendingChanges: true};
        //   const subTaskIndex = $scope.callModel.destination.subtasks.findIndex(st => st.id === subtask.id);
        //   $scope.callModel.destination.subtasks.splice(subTaskIndex, 1, subtaskCopy);
        // }

        $scope.onAddSubTask = (subtask, taskType) => {
          $scope.callModel.destination.subtasks.push(subtask);
        }

        $scope.onRemoveSubtask = (subtask, index, taskType) => {
          $scope.callModel.destination.subtasks.splice(index, 1);
        }

        $scope._loadOrderSettings = (selectedPricePlanType) => {

          const quoteTypes = ['TimeSlot', 'PerTask'];

          self.ordersService.getOrderSettings(account.id, call.serviceType, selectedPricePlanType, quoteTypes, undefined, undefined, visitPlan.from, visitPlan.zoneId)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.availableDays = _.get(serviceRef, 'availableDays', []);
              const today = _.find($scope.availableDays, (d) => {
                return self.moment().isSame(self.moment(d), 'day');
              })
              $scope.selectedDate = $scope.availableDays.length ? self.moment(today || _.head($scope.availableDays)).toDate() : undefined;

              $scope.subTaskOptionsMap = {
                [CallStopPurposeEnum.Pickup]: [],
                [CallStopPurposeEnum.Dropoff]: [],
                [CallStopPurposeEnum.Operation]: []
              }

              serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Pickup)) {
                  $scope.subTaskOptionsMap.Pickup.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Dropoff)) {
                  $scope.subTaskOptionsMap.Dropoff.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Operation)) {
                  $scope.subTaskOptionsMap.Operation.push(optionalSubTask);
                }
              })

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;

              // $scope.call.destination.subtasks.initial.value = _.filter(serviceRef.defaultSubTasks, (defaultSubTask) => {
              //   return defaultSubTask.purposes.includes($scope.call.destination.purpose)
              // });

              serviceRef.defaultSubTasks.forEach(defaultSubTask => {
                $scope.callModel.destination.subtasks.push(defaultSubTask);
              })

              // $scope.call.destination.subtasks.initial.value.forEach(st => {
              //   st.actions = $scope._getSubTaskActionsWithDefaults(st);
              // })

              // if ($scope.call.destination.purpose === CallStopPurposeEnum.Operation) {
              //   $scope.call.destination.serviceTime.initial.value = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime', {})
              // }

            })
        }

        if (account) {
          $scope.account = account;
          $scope.loading = true;
          return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id)
            .then((pricePlanBundle) => {
              $scope.programTypes = filter(pricePlanBundle.entryList, (e) => {
                return e.enabled && e.name !== "Delivery";
              });

              return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType(account.id, $scope.serviceType);
            })
            .then((defaultPricePlanTypeByServiceType) => {
              // $scope.callCopy.programType.initial.value = get(defaultPricePlanTypeByServiceType, 'pricePlanType');

              if ($scope.callCopy.programType.initial.value) {
                $scope._loadOrderSettings($scope.callCopy.programType.initial.value);
              }
            })
            .catch((error) => {
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

      }
    })
  }

  onViewVisitPlanTrackedChanges(visitPlan, isNotSynced?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/visit-plan-tracked-changes-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.visitPlan = visitPlan;
        $scope.isNotSynced = isNotSynced;

        $scope.selectedIds = [];
        $scope.excludeMode = true;

        // $scope.excludedIds = [];

        $scope.cancel = self.$mdDialog.cancel;

        ////////////////////////////

        $scope.onSelectIdsChanged = (selectedIds, excludeMode) => {
          $scope.selectedIds = selectedIds;
          $scope.excludeMode = excludeMode;
        }

        $scope.onSyncChanges = () => {
          self.$mdDialog.hide({syncChanges: true});
        }

        $scope.onDiscardChanges = () => {

          const payload: { includeIds?: string[], excludeIds?: string[], action?: string } = {}
          if (!$scope.excludeMode) {
            payload.includeIds = $scope.selectedIds;
          } else {
            payload.excludeIds = $scope.selectedIds;
          }
          payload.action = 'discard';
          self.$mdDialog.hide(payload);

          // this.$mdDialog.hide({discardIds: $scope.selectedIds});
        }

        $scope.onSubmit = () => {

          const payload: { includeIds?: string[], excludeIds?: string[], action?: string } = {}
          if (!$scope.excludeMode) {
            payload.includeIds = $scope.selectedIds;
          } else {
            payload.excludeIds = $scope.selectedIds;
          }
          payload.action = 'save';
          self.$mdDialog.hide(payload);
        }
      }
    })
  }

  dispatchRoutesConfirmDialog(visitPlan: VisitPlanModel, visitScheduleDays: VisitScheduleDayModel[], event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dispatch-routes-confirm-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.visitPlan = visitPlan;
        $scope.visitScheduleDays = visitScheduleDays;

        $scope.payload = {
          isDispatchLeftovers: false,
          autoAssignRoutes: true
        }
        $scope.isAdvancedExpanded = false;
        $scope.totals = {
          totalRoutes: 0,
          dispatchedRoutes: 0,
          undispatchedRoutes: 0,
          undispatchedLeftovers: 0,
          totalJobsToDispatch: 0
        }

        $scope.visitScheduleDays.forEach(visitScheduleDay => {
          const totals = visitScheduleDay.totals;

          $scope.totals.totalRoutes += totals.totalRoutes || 0;
          $scope.totals.dispatchedRoutes += totals.dispatchedRoutes || 0;
          $scope.totals.undispatchedRoutes += ((totals.publishedRoutes || 0) - (totals.dispatchedRoutes || 0));
          $scope.totals.undispatchedLeftovers += (totals.totalLeftovers || 0) - (totals.dispatchedLeftovers || 0);
          $scope.totals.totalJobsToDispatch += ((totals.totalJobs || 0) - (totals.totalLeftovers || 0));
        })

        $scope.cancel = self.$mdDialog.cancel;

        ////////////////////////////

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.payload);
        }
      }
    })
  }

  visitPlanProcessingDialog(visitPlan: VisitPlanModel) {
    const self = this;
    const isLoaderOn = angular.element(document.body).hasClass('md-dialog-is-showing');

    if (isLoaderOn) {
      return;
    }

    return this.$mdDialog.show({
      parent: angular.element(document.querySelector('#visit-plan-view-container')) ||
        angular.element(document.querySelector('#visit-plan-calendar-view-container')) ||
        angular.element(document.body),
      template: require('./../views/scheduling-project-processing-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      // fullscreen: true,
      controller: function ($scope, pollingIntervalService: PollingIntervalService, batchRecoveryService: BatchRecoveryService) {
        const processes: Set<ProcessTrackingTypeEnum> = new Set();
        const batchTypes: Set<BatchTypeEnum> = new Set();

        $scope.hide = self.$mdDialog.hide;

        const buildResult = (recoveryAction?: RecoveryActionEnum) => ({
          processes: Array.from(processes),
          batchTypes: Array.from(batchTypes),
          recoveryAction
        });

        const RECOVERABLE_BATCH_TYPES = [BatchTypeEnum.CreateVisitPlan, BatchTypeEnum.SyncVisitPlanAccounts, BatchTypeEnum.UpdateDeliveryData, BatchTypeEnum.RecalculateVisitPlan];

        $scope.canRecover = batchRecoveryService.canRecover();
        $scope.recoveryActions = RecoveryActionEnum;
        $scope.recoveryProcess = null;
        $scope.recoveryOptions = null;
        $scope.recoveryLoading = false;
        $scope.pendingRecoveryAction = null;
        $scope.pendingRecoveryMessage = null;

        const resetRecoveryState = () => {
          $scope.recoveryProcess = null;
          $scope.recoveryOptions = null;
          $scope.recoveryLoading = false;
          $scope.pendingRecoveryAction = null;
          $scope.pendingRecoveryMessage = null;
        };

        const loadRecoveryOptions = () => {
          $scope.recoveryLoading = true;

          batchRecoveryService.getOptions($scope.recoveryProcess.batchId)
            .subscribe({
              next: (recoveryOptions) => {
                $scope.recoveryLoading = false;
                $scope.pendingRecoveryAction = null;
                $scope.pendingRecoveryMessage = null;

                if (recoveryOptions.awaitingRecovery || recoveryOptions.stalled) {
                  $scope.recoveryOptions = recoveryOptions;
                  $scope.$applyAsync();
                  return;
                }

                resetRecoveryState();
                $scope.processTracking = null;
                $scope.isProcessDone = false;
                poller = pollingIntervalService.start($scope, pollProcess, self.PULLING_INTERVAL);
                $scope._getProcess();
                $scope.$applyAsync();
              },
              error: () => {
                $scope.recoveryLoading = false;
                $scope.$applyAsync();
              }
            });
        };

        const enterRecovery = (process: BatchProcessTrackingModel) => {
          $scope.recoveryProcess = process;

          if (!$scope.canRecover) {
            $scope.$applyAsync();
            return;
          }

          poller.cancel();
          loadRecoveryOptions();
        };

        $scope.onRecoveryAction = (action: RecoveryActionEnum) => {
          if (action !== RecoveryActionEnum.RETRY && $scope.pendingRecoveryAction !== action) {
            $scope.pendingRecoveryAction = action;
            $scope.pendingRecoveryMessage = action === RecoveryActionEnum.SKIP ? 'BATCH_RECOVERY_SKIP_CONFIRM' : 'BATCH_RECOVERY_CANCEL_CONFIRM';
            return;
          }

          $scope.pendingRecoveryAction = null;
          $scope.pendingRecoveryMessage = null;
          $scope.recoveryLoading = true;

          batchRecoveryService.execute(action, $scope.recoveryProcess.batchId)
            .subscribe({
              next: () => {
                if (action === RecoveryActionEnum.CANCEL) {
                  poller.cancel();
                  $scope.visitPlanSubscription?.unsubscribe();
                  $scope.hide(buildResult(RecoveryActionEnum.CANCEL));
                  return;
                }
                loadRecoveryOptions();
              },
              error: () => loadRecoveryOptions()
            });
        };

        $scope.cancelPendingRecoveryAction = () => {
          $scope.pendingRecoveryAction = null;
          $scope.pendingRecoveryMessage = null;
        };

        const pollProcess = () => {
          if ($scope.canRecover && !!$scope.recoveryProcess) {
            return;
          }
          const status = _.get($scope.processTracking, 'processStatus');
          if (!$scope.processTracking || (status === ProcessTrackingStatusEnum.IN_PROGRESS && !$scope.isProcessDone)) {
            $scope._getProcess();
          } else {
            poller.cancel();
          }
        };
        let poller = pollingIntervalService.start($scope, pollProcess, self.PULLING_INTERVAL);

        let latestVisitPlanStatus: VisitPlanStatusEnum = visitPlan.status;
        let visitPlanStatusPoller: PollingIntervalRef;

        // Fallback in case the visit plan channel update is missed - refresh the visit plan in the store until it settles
        const pollVisitPlanUntilSettled = () => {
          if (visitPlanStatusPoller) {
            return;
          }

          visitPlanStatusPoller = pollingIntervalService.start($scope, () => {
            self.visitPlanFacadeService.getVisitPlan(visitPlan.id)
              .subscribe({
                next: (updatedVisitPlan: VisitPlanModel) => {
                  if (!!updatedVisitPlan) {
                    self.visitPlanFacadeService.setOne(updatedVisitPlan);
                  }
                },
                error: (err) => console.error('Failed to load visit plan', err)
              });
          }, self.PULLING_INTERVAL);
        };

        // The dialog closes only by the visit plan status - process tracking may end before the status flips back from Processing/Import
        const hideIfVisitPlanSettled = () => {
          const isVisitPlanSettled = !!latestVisitPlanStatus
            && latestVisitPlanStatus !== VisitPlanStatusEnum.Processing
            && latestVisitPlanStatus !== VisitPlanStatusEnum.Import;

          if (isVisitPlanSettled && ($scope.isProcessDone || _.isUndefined($scope.isProcessDone))) {
            $scope.visitPlanSubscription?.unsubscribe();

            poller.cancel();
            visitPlanStatusPoller?.cancel();

            $scope.hide(buildResult());
          } else if ($scope.isProcessDone === true) {
            pollVisitPlanUntilSettled();
          }
        };

        $scope.visitPlanSubscription = self.visitPlanFacadeService.selectOne(visitPlan.id)
          .subscribe((visitPlan: VisitPlanModel) => {
            latestVisitPlanStatus = visitPlan?.status;
            hideIfVisitPlanSettled();
          });

        // watch for ui router state change start
        $scope.$on('$stateChangeStart', () => {
          $scope.visitPlanSubscription?.unsubscribe();
        });

        const isDispatchProcess = (process: ProcessTrackingModel): boolean => {
          const batchProcess = process as BatchProcessTrackingModel;

          return process?.processType === ProcessTrackingTypeEnum.SchedulingProjectDispatch
            || (process?.processType === ProcessTrackingTypeEnum.BatchProcess && batchProcess?.batchType === BatchTypeEnum.DispatchVisitSchedule);
        };

        $scope._getProcess = () => {
          self.visitPlanHttpService.getVisitPlanProcessTracking(visitPlan.id, { status: ProcessTrackingStatusEnum.IN_PROGRESS })
            .subscribe({
              next: (processTracking) => {
                processTracking?.forEach(process => processes.add(process.processType));
                _.compact(_.map(processTracking as BatchProcessTrackingModel[], 'batchType')).forEach(batchType => batchTypes.add(batchType));

                const stalledProcess = _.find(processTracking, (process) => batchRecoveryService.isCandidate(process, RECOVERABLE_BATCH_TYPES));
                if (stalledProcess) {
                  enterRecovery(stalledProcess as BatchProcessTrackingModel);
                  return;
                }
                resetRecoveryState();

                if ($scope.isProcessDone) {
                  poller.cancel();
                  hideIfVisitPlanSettled();
                  return;
                }

                if (!processTracking?.length) {
                  $scope._checkRecoveryFallback();
                  return;
                }

                $scope.processTracking = _.last(processTracking);
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.SchedulingProjectImport) {
                  const accountRef = $scope.processTracking.progressMap[ProcessTrackingMeasurementTypeEnum.Account];
                  $scope.progress = (accountRef?.created || 0) / (accountRef?.total || 0) * 100;
                }
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.SchedulingProjectSubmitChanges) {
                  const accountRef = $scope.processTracking.progressMap[ProcessTrackingMeasurementTypeEnum.Account];
                  $scope.progress = (accountRef?.updated || 0) / (accountRef?.total || 0) * 100;
                }
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.BatchProcess
                    && ($scope.processTracking as BatchProcessTrackingModel).batchType === BatchTypeEnum.RecalculateVisitPlan) {
                  const accountRef = $scope.processTracking.progressMap[ProcessTrackingMeasurementTypeEnum.Account];
                  $scope.progress = (accountRef?.updated || 0) / (accountRef?.total || 0) * 100;
                }
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.PlanningOptimizing) {
                  const accountRef = $scope.processTracking.progressMap[ProcessTrackingMeasurementTypeEnum.Account];
                  $scope.progress = (accountRef?.updated || 0) / (accountRef?.total || 0) * 100;
                }
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.BatchProcess
                    && ($scope.processTracking as BatchProcessTrackingModel).batchType === BatchTypeEnum.UpdateDeliveryData) {
                  const accountRef = $scope.processTracking.progressMap[ProcessTrackingMeasurementTypeEnum.Account];
                  $scope.progress = (accountRef?.updated || 0) / (accountRef?.total || 0) * 100;
                }
                $scope.schedulingProjectDispatch = isDispatchProcess($scope.processTracking);

                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.PlanningOptimizing ||
                    $scope.processTracking?.processType === ProcessTrackingTypeEnum.ProcessTrackingPercentage) {
                  $scope.planningOptimizing = true;
                }

                $scope.isProcessDone = !processTracking.length;
              },
              error: (err) => {
                console.error('Failed to load process tracking', err);
              }
            });
        };

        $scope._checkRecoveryFallback = () => {
          self.visitPlanHttpService.getVisitPlanProcessTracking(visitPlan.id, { type: ProcessTrackingTypeEnum.BatchProcess })
          .subscribe({
            next: (processTracking) => {
              const recoveryCandidate = _.find(processTracking, (process) => batchRecoveryService.isCandidate(process, RECOVERABLE_BATCH_TYPES));
              if (recoveryCandidate) {
                enterRecovery(recoveryCandidate as BatchProcessTrackingModel);
                return;
              }
              $scope.processTracking = null;
              $scope.isProcessDone = true;
              hideIfVisitPlanSettled();
            },
            error: (err) => {
              console.error('Failed to load batch process tracking', err);
              $scope.processTracking = null;
              $scope.isProcessDone = true;
              hideIfVisitPlanSettled();
            }
          });
        };

        $scope._getProcess();
      }
    });
  }
  visitScheduleProcessingDialog(visitPlan: VisitPlanModel, visitSchedule: VisitScheduleModel) {

    const self = this;
    const isLoaderOn = angular.element(document.body).hasClass('md-dialog-is-showing');

    if (isLoaderOn) {
      return;
    }

    return this.$mdDialog.show({
      parent: angular.element(document.querySelector('#visit-plan-view-container')) ||
        angular.element(document.querySelector('#visit-plan-calendar-view-container')) ||
        angular.element(document.body),
      template: require('./../views/scheduling-project-processing-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      // fullscreen: true,
      controller: function ($scope, pollingIntervalService: PollingIntervalService, visitPlanHttpService, schedulingProjectAlertsService, batchRecoveryService: BatchRecoveryService) {

        $scope.cancel = self.$mdDialog.cancel;

        $scope.visitPlan = visitPlan;

        const RECOVERABLE_BATCH_TYPES = [BatchTypeEnum.PublishVisitSchedule, BatchTypeEnum.DispatchVisitSchedule];

        $scope.canRecover = batchRecoveryService.canRecover();
        $scope.recoveryActions = RecoveryActionEnum;
        $scope.recoveryProcess = null;
        $scope.recoveryOptions = null;
        $scope.recoveryLoading = false;
        $scope.pendingRecoveryAction = null;
        $scope.pendingRecoveryMessage = null;

        const resetRecoveryState = () => {
          $scope.recoveryProcess = null;
          $scope.recoveryOptions = null;
          $scope.recoveryLoading = false;
          $scope.pendingRecoveryAction = null;
          $scope.pendingRecoveryMessage = null;
        };

        const loadRecoveryOptions = () => {
          $scope.recoveryLoading = true;

          batchRecoveryService.getOptions($scope.recoveryProcess.batchId)
            .subscribe({
              next: (recoveryOptions) => {
                $scope.recoveryLoading = false;
                $scope.pendingRecoveryAction = null;
                $scope.pendingRecoveryMessage = null;

                if (recoveryOptions.awaitingRecovery || recoveryOptions.stalled) {
                  $scope.recoveryOptions = recoveryOptions;
                  $scope.$applyAsync();
                  return;
                }

                resetRecoveryState();
                $scope.processTracking = null;
                $scope.isProcessDone = false;
                $scope._getProcess();
                $scope.$applyAsync();
              },
              error: () => {
                $scope.recoveryLoading = false;
                $scope.$applyAsync();
              }
            });
        };

        const enterRecovery = (process: BatchProcessTrackingModel) => {
          $scope.recoveryProcess = process;

          if (!$scope.canRecover) {
            $scope.$applyAsync();
            return;
          }

          poller.cancel();
          loadRecoveryOptions();
        };

        $scope.onRecoveryAction = (action: RecoveryActionEnum) => {
          if (action !== RecoveryActionEnum.RETRY && $scope.pendingRecoveryAction !== action) {
            $scope.pendingRecoveryAction = action;
            $scope.pendingRecoveryMessage = action === RecoveryActionEnum.SKIP ? 'BATCH_RECOVERY_SKIP_CONFIRM' : 'BATCH_RECOVERY_CANCEL_CONFIRM';
            return;
          }

          $scope.pendingRecoveryAction = null;
          $scope.pendingRecoveryMessage = null;
          $scope.recoveryLoading = true;

          batchRecoveryService.execute(action, $scope.recoveryProcess.batchId)
            .subscribe({
              next: () => {
                if (action === RecoveryActionEnum.CANCEL) {
                  poller.cancel();
                  $scope.visitScheduleSubscription?.unsubscribe();
                  $scope.cancel();
                  return;
                }
                loadRecoveryOptions();
              },
              error: () => loadRecoveryOptions()
            });
        };

        $scope.cancelPendingRecoveryAction = () => {
          $scope.pendingRecoveryAction = null;
          $scope.pendingRecoveryMessage = null;
        };

        const poller = pollingIntervalService.start($scope, () => {
          if ($scope.canRecover && !!$scope.recoveryProcess) {
            return;
          }
          const status = _.get($scope.processTracking, 'processStatus');
          if ((!$scope.processTracking) || (status === ProcessTrackingStatusEnum.IN_PROGRESS && !$scope.isProcessDone)) {
            $scope._getProcess();
          } else {
            poller.cancel();
          }
        }, self.PULLING_INTERVAL);

        $scope.visitScheduleSubscription = self.visitScheduleFacadeService.selectOne(visitSchedule.id)
          .subscribe((visitSchedule: VisitScheduleModel) => {
            if (visitSchedule?.status === VisitScheduleStatusEnum.Ongoing) {
              $scope.visitScheduleSubscription?.unsubscribe();

              poller.cancel();

              $scope.cancel();
            }
          });

        // watch for ui router state change start
        $scope.$on('$stateChangeStart', () => {
          $scope.visitScheduleSubscription?.unsubscribe();
        });

        const isPublishProcess = (process: ProcessTrackingModel): boolean => {
          const batchProcess = process as BatchProcessTrackingModel;

          return process?.processType === ProcessTrackingTypeEnum.SchedulingProjectPublish
            || (process?.processType === ProcessTrackingTypeEnum.BatchProcess && batchProcess?.batchType === BatchTypeEnum.PublishVisitSchedule);
        };

        const isDispatchProcess = (process: ProcessTrackingModel): boolean => {
          const batchProcess = process as BatchProcessTrackingModel;

          return process?.processType === ProcessTrackingTypeEnum.SchedulingProjectDispatch
            || (process?.processType === ProcessTrackingTypeEnum.BatchProcess && batchProcess?.batchType === BatchTypeEnum.DispatchVisitSchedule);
        };

        $scope._getProcess = () => {
          self.visitPlanHttpService.getVisitScheduleProcessTracking(visitPlan.id, visitSchedule.id, {status: ProcessTrackingStatusEnum.IN_PROGRESS})
            .subscribe({
              next: (processTracking) => {
                const latestProcess = _.last(processTracking);

                if (batchRecoveryService.isCandidate(latestProcess, RECOVERABLE_BATCH_TYPES)) {
                  enterRecovery(latestProcess as BatchProcessTrackingModel);
                  return;
                }

                resetRecoveryState();

                if (!processTracking?.length) {
                  $scope._checkRecoveryFallback();
                  return;
                }

                $scope.processTracking = latestProcess;
                $scope.schedulingProjectPublish = isPublishProcess($scope.processTracking);
                $scope.schedulingProjectDispatch = isDispatchProcess($scope.processTracking);

                if ($scope.schedulingProjectPublish) {
                  const agentRef = $scope.processTracking.progressMap[ProcessTrackingMeasurementTypeEnum.Agent];
                  $scope.progress = (agentRef?.updated || 0) / (agentRef?.total || 0) * 100;
                }
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.ProcessTrackingPercentage) {
                  const progressPercentage = $scope.processTracking.progressPercentage;
                  $scope.progress = (progressPercentage || 0)
                }
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.PlanningOptimizing) {
                  const accountRef = $scope.processTracking.progressMap[ProcessTrackingMeasurementTypeEnum.Account];
                  $scope.progress = (accountRef?.updated || 0) / (accountRef?.total || 0) * 100;
                }
                if ($scope.processTracking?.processType === ProcessTrackingTypeEnum.PlanningOptimizing ||
                  $scope.processTracking?.processType === ProcessTrackingTypeEnum.ProcessTrackingPercentage
                ) {
                  $scope.planningOptimizing = true;
                }

                $scope.isProcessDone = !processTracking.length;
                $scope.isPublish = $scope.schedulingProjectPublish;
              },
              error: (err) => {
                console.error('Failed to load process tracking', err);
              }
            })
        };

        $scope._checkRecoveryFallback = () => {
          self.visitPlanHttpService.getVisitScheduleProcessTracking(visitPlan.id, visitSchedule.id, {type: ProcessTrackingTypeEnum.BatchProcess})
            .subscribe({
              next: (processTracking) => {
                const recoveryCandidate = _.find(processTracking, (process) => batchRecoveryService.isCandidate(process, RECOVERABLE_BATCH_TYPES));

                if (recoveryCandidate) {
                  enterRecovery(recoveryCandidate as BatchProcessTrackingModel);
                  return;
                }

                $scope.processTracking = null;
                $scope.isProcessDone = true;
              },
              error: (err) => {
                console.error('Failed to load batch process tracking', err);
                $scope.processTracking = null;
                $scope.isProcessDone = true;
              }
            })
        };

        $scope._getProcess();

        $scope.onAbortPublish = () => {
          $scope.loading = true;
          poller.cancel();

          visitPlanHttpService.visitScheduleAbortPublish(visitPlan.id, visitPlan.scheduleId)
            .subscribe(() => {
              schedulingProjectAlertsService.visitSchedulePublishAbortSuccess();
              $scope.cancel();
            })
        }

        $scope.onAbort = () => {
          $scope.loading = true;
          poller.cancel();

          visitPlanHttpService.visitScheduleAbort(visitPlan.id, visitPlan.scheduleId)
            .subscribe(() => {
              schedulingProjectAlertsService.visitScheduleOptimizationAbortSuccess();
              $scope.cancel();
            })
        }

      }
    })
  }

  editVisitPlanName(visitPlan: VisitPlanModel, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/edit-visit-plan-name-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {
        $scope.visitPlan = angular.copy(visitPlan);

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form.$valid) {
            self.$mdDialog.hide($scope.visitPlan);
          }
        }
      }
    })
  }

  showAvailabilityDialog(visitPlan: VisitPlanModel, visitScheduleId, branchIds, from, to, zoneId, event?, presetEmployeeIds?: string[]) {
    const self = this;
    let allUpdatedResources = [];
    let importedExternalResourceHolder = false;

    const dialogPromise = this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/availability-table-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $timeout, panelService: PanelService, bringozLoaderService: BringozLoaderService) {
        $scope.visitPlan = visitPlan;
        $scope.visitScheduleId = visitScheduleId;
        $scope.branchIds = branchIds;
        $scope.from = from;
        $scope.to = to;
        $scope.zoneId = zoneId;
        $scope.searchQuery = '';

        // Filter state
        $scope.filterEmployeeIds = presetEmployeeIds || [];
        $scope.filterOperationalUnitIds = [];
        $scope.filterTerritoryIds = [];
        $scope.filterTeamIds = [];
        $scope.filterTags = [];
        $scope.filterExternal = undefined;

        $scope._panelSubscription = undefined;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.close = () => {
          $scope._panelSubscription?.unsubscribe();
          // Pass updated resources back to parent view
          self.$mdDialog.hide({
            success: true,
            resources: allUpdatedResources,
            refreshSchedule: importedExternalResourceHolder
          });
        };

        $scope.onSearchQueryChange = (query) => {
          $scope.searchQuery = query;
          $timeout(() => {});
        };

        $scope.onExternalFilterChange = (filterExternal) => {
          $scope.filterExternal = filterExternal;
          $timeout(() => {});
        };

        $scope.onEmployeeFilterChange = (selectedIds) => {
          $scope.filterEmployeeIds = selectedIds || [];
          $timeout(() => {});
        };

        $scope.onOperationalUnitFilterChange = (selectedIds) => {
          $scope.filterOperationalUnitIds = selectedIds || [];
          $timeout(() => {});
        };

        $scope.onTerritoryFilterChange = (selectedIds) => {
          $scope.filterTerritoryIds = selectedIds || [];
          $timeout(() => {});
        };

        $scope.onTeamFilterChange = (selectedIds) => {
          $scope.filterTeamIds = selectedIds || [];
          $timeout(() => {});
        };

        $scope.onTagsChange = (selectedIds) => {
          $scope.filterTags = selectedIds || [];
          $timeout(() => {});
        };

        $scope.onResourcesUpdate = (updatedResources) => {
          // Collect updated resources to pass back to parent (using outer scope variable)
          if (updatedResources && updatedResources.length) {
            allUpdatedResources = [...allUpdatedResources, ...updatedResources];
          }
        };

        $scope.onImport = (ev) => {
          const panel = panelService.open(VisitScheduleAgentImportDialogComponent,
            ev,
            {visitPlanId: visitPlan.id, visitScheduleId: visitScheduleId},
            {
              position: {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
              },
              height: 400,
              width: 400
            });
          if (panel) {
            $scope._panelSubscription?.unsubscribe();
            $scope._panelSubscription = panel.afterClose$.subscribe(agentIds => {
              if (agentIds && agentIds.length) {
                $scope.reload = false;
                bringozLoaderService.on();
                self.visitPlanFacadeService.importExternalAgentsResourceHolders(visitPlan.id, visitScheduleId, agentIds)
                  .pipe(finalize(() => bringozLoaderService.off()))
                  .subscribe({
                    next: (res) => {
                      self.schedulingProjectAlertsService.importAgentsSuccess();
                      importedExternalResourceHolder = true;
                      $scope.reload = true;
                    },
                    error: (err) => {
                      self.schedulingProjectAlertsService.importAgentsError();
                    }
                  })
              }
            });
          }

          $timeout(() => {});
        }

      }
    });

    // Wrap the promise to handle both hide and cancel cases
    return dialogPromise.then(
      (result) => {
        // Dialog closed with hide() - return the result
        return result;
      },
      () => {
        // Dialog cancelled (backdrop click, ESC, or cancel button)
        // Still return the updated resources since changes are applied immediately
        return {
          success: true,
          refreshSchedule: importedExternalResourceHolder,
          resources: allUpdatedResources
        };
      }
    );
  }

  showPublishConflictsDialog(event?): Promise<boolean> {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/publish-conflicts-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.cancel = () => self.$mdDialog.cancel();
        $scope.goToAvailability = () => self.$mdDialog.hide(true);
      }
    }).then(() => true, () => false);
  }

  showEditedAfterPublishDialog(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/edited-after-publish-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      controller: function ($scope) {
        $scope.confirm = () => self.$mdDialog.hide();
      }
    });
  }

  createOptimizeVisitScheduleFormDialog(event, params?: {
    tabs?: string[],
    visitScheduleOptimizationSettings?: VisitScheduleOptimizationSettings,
    visitScheduleResourceSettings?: VisitScheduleResourceSettingsModel,
    visitDays?: VisitScheduleDayModel[]
  }) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/optimize-visit-schedule-dialog.html').default,
      controller: function ($scope) {
        $scope.header = 'Set Optimization Parameters For Visit Schedule';

        $scope.tabs = [...params.tabs];
        $scope.visitDays = params.visitDays ? [...params.visitDays] : [];
        $scope.selectedVisitDays = [];

        if (self.IAMPermissions.hasPermission('schedulingProject.optimization.update')) {
          $scope.visitScheduleOptimizationSettings = self._processVisitScheduleOptimizationSettings(params.visitScheduleOptimizationSettings);
        }

        $scope.visitScheduleResourceSettings = params.visitScheduleResourceSettings;

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            if ($scope.visitDays.length > 0 && $scope.selectedVisitDays.length === 0) {
              let message = {
                details: 'COMMONS_FORM_INVALID_INFO',
                body: 'PLEASE_SELECT_AT_LEAST_ONE_VISIT_DAY'
              };
              self.bringozToastService.error(message)
              return;
            }
            form.$setSubmitted(true);
            if (form.$valid) {
              const payload: { [key: string]: any } = {
                selectedVisitDays: $scope.selectedVisitDays
              };

              if ($scope.visitScheduleOptimizationSettings) {
                payload.visitScheduleOptimizationSettings = $scope.visitScheduleOptimizationSettings;
              }

              self.$mdDialog.hide(payload);
            }
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  createVisitPlanTemplate(event, templateData?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-visit-plan-template-dialog.html').default,
      controller: function ($scope) {
        const isEdit = !!templateData;
        $scope.header = isEdit ? 'Edit Template' : 'Create New Template';

        $scope.templateName = templateData?.name || '';
        $scope.tabs = ['filtering', 'providers', 'hardConstraints', 'softConstraints', 'projectAutomation', 'schedulingProjectRules'];
        $scope.templateAccessControls = {
          global: templateData?.global !== false,
          branchIds: templateData?.branchIds ? [...templateData.branchIds] : [],
          groupIds: templateData?.groupIds ? [...templateData.groupIds] : []
        };
        $scope.visitDays = [];
        $scope.selectedVisitDays = [];

        // Initialize schedule project for providers
        $scope.scheduleProject = {
          deliveryProviderType: templateData?.deliveryProviderType || SchedulingProjectProviderType.System,
          visitCallProviderType: templateData?.visitCallProviderType || SchedulingProjectVisitCallProviderType.VisitCall,
          accountImportMode: templateData?.accountImportMode || VisitPlanAccountImportMode.System,
          agentImportMode: templateData?.agentImportMode || VisitPlanAgentImportMode.System,
          schedulingProjectRules: templateData?.schedulingProjectRules || {
            allowedEndDays: [],
            allowedStartDays: []
          }
        };

        $scope.visitPlanSettings = {
          autoTriggerRecalcAfterPullingActualData: templateData?.visitPlanSettings?.autoTriggerRecalcAfterPullingActualData ?? false
        };

        $scope.visitScheduleResourceSettings = templateData?.visitScheduleResourceSettings || {
          allowCrossDayResources:  false,
          crossDayResourcesBufferHours: undefined
        }

        // Replaced by what the selects can actually show once the data sources land; submitting is
        // blocked until then, so this only has to be an object the handlers can write to.
        $scope.templateProviderSelection = {};

        // Left undefined until the data sources arrive - the selects render off these lists, and a
        // select handed a saved id it cannot find a name for throws while labelling itself.
        $scope.providerOptions = undefined;

        const providersSubscription = self.siteProvidersService.getAll().subscribe({
          next: (providers: SiteProviderModel[]) => {
            $scope.providerOptions = buildTemplateProviderOptions(providers, templateData);
            $scope.templateProviderSelection = resolveTemplateProviderSelection($scope.providerOptions, templateData);
            $scope.$applyAsync();
          },
          error: (error) => {
            console.error('Failed to load scheduling project data sources', error);
            self.bringozToastService.error({details: 'COMMONS_FORM_INVALID_INFO', body: 'PROVIDERS_LOAD_ERROR'});
          }
        });

        $scope.$on('$destroy', () => providersSubscription.unsubscribe());

        // Provider selection handlers
        $scope.onSelectServiceTimeProvider = (value) => {
          $scope.templateProviderSelection.serviceTimeId = value;

          // The prediction source is a second opinion on service time - without a service time
          // provider there is nothing for it to run alongside.
          if (!value) {
            $scope.templateProviderSelection.serviceTimeVisitCallPredictionId = undefined;
          }
        }

        $scope.onSelectUnitsProvider = (value) => {
          $scope.templateProviderSelection.unitsId = value;
        }

        $scope.onSelectDeliveryTimeProvider = (value) => {
          $scope.templateProviderSelection.deliveryTimeId = value;
        }

        $scope.onSelectServiceTimeVisitCallPredictionProvider = (value) => {
          $scope.templateProviderSelection.serviceTimeVisitCallPredictionId = value;
        }

        // Use existing settings if editing, otherwise use defaults
        $scope.visitScheduleOptimizationSettings = self._processVisitScheduleOptimizationSettings(templateData?.visitScheduleOptimizationSettings);

        $scope.visitScheduleDispatchSettings = templateData?.visitScheduleDispatchSettings || {
          autoDispatchEnabled: false,
          autoDispatchTimeFrom: '01:00',
          autoDispatchTimeTo: '03:00'
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const isGlobal = $scope.templateAccessControls.global !== false;
              let branchIds = isGlobal ? [] : ($scope.templateAccessControls.branchIds || []);

              if (!isGlobal && !branchIds.length && $scope.templateAccessControls.groupsBranchIds?.length) {
                branchIds = [...$scope.templateAccessControls.groupsBranchIds];
              }

              const accessControlsPayload = {
                global: isGlobal,
                branchIds: branchIds,
                groupIds: isGlobal ? [] : ($scope.templateAccessControls.groupIds || [])
              };

              // The provider selects render off the loaded data sources, so a load that never
              // landed leaves the user nothing to choose from - saving here would send an empty
              // providerIds and leave the template running on no providers at all.
              if (!$scope.providerOptions) {
                self.bringozToastService.error({details: 'COMMONS_FORM_INVALID_INFO', body: 'PROVIDERS_LOAD_ERROR'});
                return;
              }

              // Combine name, settings, and providers; include ID if editing
              const payload = {
                ...(isEdit ? {id: templateData.id} : {}),
                name: $scope.templateName,
                ...accessControlsPayload,
                deliveryProviderType: $scope.scheduleProject.deliveryProviderType,
                visitCallProviderType: $scope.scheduleProject.visitCallProviderType,
                accountImportMode: $scope.scheduleProject.accountImportMode,
                agentImportMode: $scope.scheduleProject.agentImportMode,
                visitScheduleOptimizationSettings: $scope.visitScheduleOptimizationSettings,
                visitScheduleResourceSettings: $scope.visitScheduleResourceSettings,
                visitPlanSettings: $scope.visitPlanSettings,
                providerIds: buildTemplateProviderIds($scope.templateProviderSelection),
                serviceTimeVisitCallPredictionProviderId: $scope.templateProviderSelection.serviceTimeVisitCallPredictionId,
                visitScheduleDispatchSettings: $scope.visitScheduleDispatchSettings,
                schedulingProjectRules: $scope.scheduleProject.schedulingProjectRules
              };

              self.$mdDialog.hide(payload);
            }
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  private _getCurrentUserTemplateScope(groupBranchIdsMap?: Record<string, string[]>) {
    const siteInfo = this.siteContextService.getSiteInfo();

    return {
      branchIds: this.splitService.getUserSiteBranchIds() || [],
      groupIds: siteInfo.restrictedGroups || siteInfo.userRolesGroupIds || [],
      groupBranchIdsMap: groupBranchIdsMap
    };
  }

  private _processVisitScheduleOptimizationSettings(settings?: VisitScheduleOptimizationSettings): VisitScheduleOptimizationSettings {
    const constraints: ConstraintConfigurationsModel | undefined = settings?.constraintConfigurations;
    const constraintConfigurationEnabled: boolean = this.splitService.getSiteInfo().enableConstraintConfiguration ?? false;
    const constraintConfigurationAllowed: boolean = this.IAMPermissions.hasPermission('schedulingProject.template.updateConstraintConfiguration') ?? false;

    let optimizationSettings: VisitScheduleOptimizationSettings = {
      optimizeDispatchedRoutes: settings?.optimizeDispatchedRoutes ?? false,

      /* Hard Constraints */
      considerVehicleLocation: settings?.considerVehicleLocation ?? ConsiderVehicleLocation.ConsiderButDoNotIncludeInRoute,
      considerTimeWindow: settings?.considerTimeWindow ?? true,
      skillsRequired: settings?.skillsRequired ?? true,
      considerMaxHoursPer7Days: settings?.considerMaxHoursPer7Days ?? true,
      considerDailyMaxHours: settings?.considerDailyMaxHours ?? true,
      respectAssignedBranchesHard: settings?.respectAssignedBranchesHard ?? false,
      considerRestrictedAgentsFromAccounts: settings?.considerRestrictedAgentsFromAccounts ?? true,
      considerAccountStrategyPriority: settings?.considerAccountStrategyPriority ?? true,
      considerDedicatedAgents: settings?.considerDedicatedAgents ?? true,

      /* Soft Constraints */
      considerWeeklyHoursGoal: settings?.considerWeeklyHoursGoal ?? true,
      considerDailyHoursGoal: settings?.considerDailyHoursGoal ?? true,
      considerPreferredAgents: settings?.considerPreferredAgents ?? true,
      minimizeAccountVisits: settings?.minimizeAccountVisits ?? true,
      respectAssignedBranchesSoft: settings?.respectAssignedBranchesSoft ?? true,
      rolesPriority: settings?.rolesPriority ?? true,
      bundling: settings?.bundling ?? true,
      serviceTimeSettings: settings?.serviceTimeSettings ?? {},
      locationSettings: settings?.locationSettings ?? {},
      planningServer: settings?.planningServer ?? PlanningServerEnum.DEFAULT,
    };

    if (constraintConfigurationEnabled && constraintConfigurationAllowed) {
      optimizationSettings.constraintConfigurations = {
        branchRouteConstraint: this._toConstraintConfiguration(constraints?.branchRouteConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('branchRouteConstraint')),
        locationClusterSoftConstraint: this._toConstraintConfiguration(constraints?.locationClusterSoftConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('locationClusterSoftConstraint')),
        locationVehiclePriorityUserdataConstraint: this._toConstraintConfiguration(constraints?.locationVehiclePriorityUserdataConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('locationVehiclePriorityUserdataConstraint')),
        vehicleRoleSoftActivityConstraint: this._toConstraintConfiguration(constraints?.vehicleRoleSoftActivityConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('vehicleRoleSoftActivityConstraint')),
        vehicleConsiderButNotIncludeInRouteSoftActivityConstraint: this._toConstraintConfiguration(constraints?.vehicleConsiderButNotIncludeInRouteSoftActivityConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('vehicleConsiderButNotIncludeInRouteSoftActivityConstraint')),
        minimizeLocationVisitsConstraint: this._toConstraintConfiguration(constraints?.minimizeLocationVisitsConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('minimizeLocationVisitsConstraint')),
        minimizeBundleVisitsConstraint: this._toConstraintConfiguration(constraints?.minimizeBundleVisitsConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('minimizeBundleVisitsConstraint')),
        maxRouteDurationConstraint: this._toConstraintConfiguration(constraints?.maxRouteDurationConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('maxRouteDurationConstraint')),
        maxVehicleGroupRouteDurationConstraint: this._toConstraintConfiguration(constraints?.maxVehicleGroupRouteDurationConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('maxVehicleGroupRouteDurationConstraint')),
        stopToStopDistanceConstraint: this._toConstraintConfiguration(constraints?.stopToStopDistanceConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('stopToStopDistanceConstraint')),
        softTimeWindowConstraint: this._toConstraintConfiguration(constraints?.softTimeWindowConstraint, this.VISIBLE_SOFT_CONSTRAINTS_KEYS.includes('softTimeWindowConstraint'))
      }
    } else {
      optimizationSettings.constraintConfigurations = constraints ? {...constraints} : {} as ConstraintConfigurationsModel;
      optimizationSettings.constraintConfigurations.stopToStopDistanceConstraint = this._toConstraintConfiguration(
        optimizationSettings.constraintConfigurations.stopToStopDistanceConstraint,
        false
      );
    }

    return optimizationSettings;
  }

  private _toConstraintConfiguration(value?: ConstraintConfigurationModel, enabled: boolean = false): ConstraintConfigurationModel {
    return value ? value : {
      enableConfiguration: enabled,
      weight: 0,
      disableTimeWindowCheck: false,
      disableCapacityCheck: false,
      disableBundlePresenceCheck: false,
      noBundleFitPenaltyMultiplier: 0
    };
  }

  importVisitPlanAccounts(visitPlanId: string, event?: Event) {
    const self = this;

    return this.$mdDialog.show({
      multiple: true,
      clickOutsideToClose: false,
      escapeToClose: false,
      parent: angular.element(document.body),
      targetEvent: event,
      template: require('../views/import-visit-plan-accounts-dialog.html').default,
      controller: function ($scope, pollingIntervalService: PollingIntervalService) {
        const MAX_POLL_ATTEMPTS = 120;

        let poller: PollingIntervalRef;
        let processTrackingId: string;
        let pollingInFlight = false;
        let pollingErrors = 0;
        let pollAttempts = 0;

        $scope.stage = 'upload';
        $scope.file = null;
        $scope.importResult = null;
        $scope.validRows = [];
        $scope.invalidRows = [];
        $scope.validating = false;
        $scope.submitting = false;
        $scope.requestError = null;
        $scope.requestErrorKey = null;
        $scope.progress = 0;
        $scope.completedCount = 0;
        $scope.createdCount = 0;
        $scope.failedCount = 0;
        $scope.totalCount = 0;
        $scope.noChanges = false;
        $scope.stillRunning = false;
        $scope.downloadUrl = visitPlanAccountsImportSampleFileLink;
        $scope.downloadFileName = visitPlanAccountsImportSampleFileName;

        const getErrorKey = (error: any, fallbackKey: string): string => {
          const status = _.get(error, 'status');

          if (status === 403) {
            return 'VISIT_PLAN_ACCOUNT_IMPORT.PERMISSION_ERROR';
          }

          if (status === 404) {
            return 'VISIT_PLAN_ACCOUNT_IMPORT.NOT_FOUND_ERROR';
          }

          return fallbackKey;
        };

        // The server message is already localized, the view translates the key fallbacks.
        const setRequestError = (error: any, fallbackKey: string) => {
          const response = _.get(error, 'error');
          const message = typeof response === 'string'
            ? response
            : _.get(response, 'more_info')
              || _.get(response, 'message')
              || _.get(response, 'description')
              || _.get(error, 'more_info');

          $scope.requestError = message || null;
          $scope.requestErrorKey = message ? null : getErrorKey(error, fallbackKey);
        };

        const showFailure = () => {
          poller?.cancel();
          $scope.stage = 'failure';
          $scope.$applyAsync();
        };

        const setFailure = (message?: string) => {
          $scope.requestError = message || null;
          $scope.requestErrorKey = null;
          showFailure();
        };

        const setFailureFromError = (error: any, fallbackKey: string) => {
          setRequestError(error, fallbackKey);
          showFailure();
        };

        const updateProgress = (process: ProcessTrackingModel) => {
          const accountProgress = process?.progressMap?.[ProcessTrackingMeasurementTypeEnum.Account];
          const processErrors = _.castArray(process?.errors || []);
          const processErrorMessage = _.compact(_.map(
            processErrors,
            error => typeof error === 'string'
              ? error
              : error?.description || error?.message || error?.more_info
          )).join('; ');

          $scope.totalCount = accountProgress?.total || $scope.totalCount || 0;
          $scope.createdCount = accountProgress?.created || 0;
          $scope.failedCount = accountProgress?.failed || 0;
          $scope.completedCount = $scope.createdCount + $scope.failedCount + (accountProgress?.existed || 0);
          $scope.progress = $scope.totalCount
            ? Math.min(100, $scope.completedCount / $scope.totalCount * 100)
            : 0;

          if (process.processStatus === ProcessTrackingStatusEnum.FAIL) {
            setFailure(processErrorMessage || undefined);
            return;
          }

          if (process.processStatus === ProcessTrackingStatusEnum.COMPLETED) {
            if ($scope.failedCount || processErrorMessage) {
              setFailure(processErrorMessage || undefined);
              return;
            }

            poller?.cancel();
            $scope.progress = 100;
            $scope.stage = 'success';
          }

          $scope.$applyAsync();
        };

        const pollProcess = () => {
          if (pollingInFlight || $scope.stage !== 'importing') {
            return;
          }

          // The import keeps running server side, so stop watching instead of polling forever.
          if (++pollAttempts > MAX_POLL_ATTEMPTS) {
            poller?.cancel();
            $scope.stillRunning = true;
            $scope.$applyAsync();
            return;
          }

          pollingInFlight = true;
          self.visitPlanHttpService.getVisitPlanProcessTracking(visitPlanId)
            .pipe(finalize(() => pollingInFlight = false))
            .subscribe({
              next: (processes: ProcessTrackingModel[]) => {
                pollingErrors = 0;
                const process = processTrackingId
                  ? _.find(processes, {id: processTrackingId})
                  : _.last(processes);

                // The batch may not be visible in process tracking immediately after it starts.
                if (process) {
                  updateProgress(process);
                }
              },
              error: (error) => {
                pollingErrors++;
                if (pollingErrors >= 3) {
                  setFailureFromError(error, 'VISIT_PLAN_ACCOUNT_IMPORT.PROGRESS_ERROR');
                }
              }
            });
        };

        const startPolling = (batch: AccountsImportBatchModel) => {
          processTrackingId = batch.processTrackingId;
          $scope.totalCount = batch.details?.total || $scope.validRows.length;
          $scope.completedCount = batch.details?.completed || 0;
          $scope.failedCount = batch.details?.failed || 0;
          $scope.progress = $scope.totalCount
            ? Math.min(100, $scope.completedCount / $scope.totalCount * 100)
            : 0;

          pollProcess();
          poller = pollingIntervalService.start($scope, pollProcess, 2500);
        };

        $scope.onFileChanged = (file: File) => {
          $scope.file = file;
          $scope.importResult = null;
          $scope.validRows = [];
          $scope.invalidRows = [];
          $scope.requestError = null;
          $scope.requestErrorKey = null;
          $scope.stage = 'upload';

          if (!file) {
            return;
          }

          $scope.validating = true;
          self.visitPlanHttpService.validateAccountsImport(file, visitPlanId)
            .pipe(finalize(() => {
              $scope.validating = false;
              $scope.$applyAsync();
            }))
            .subscribe({
              next: (rows: AccountsImportValidateRowModel[]) => {
                $scope.importResult = rows || [];
                $scope.validRows = _.filter($scope.importResult, row => !row.mappingErrors?.length);
                $scope.invalidRows = _.filter($scope.importResult, row => !!row.mappingErrors?.length);
                $scope.stage = 'preview';
                $scope.$applyAsync();
              },
              error: (error) => {
                $scope.file = null;
                setRequestError(error, 'VISIT_PLAN_ACCOUNT_IMPORT.VALIDATION_ERROR');
                $scope.$applyAsync();
              }
            });
        };

        $scope.submit = () => {
          if (!$scope.validRows.length || $scope.submitting) {
            return;
          }

          $scope.submitting = true;
          $scope.stage = 'importing';
          $scope.requestError = null;
          $scope.requestErrorKey = null;
          $scope.totalCount = $scope.validRows.length;

          // Send the clean validation rows unchanged: the backend needs the complete entities.
          self.visitPlanHttpService.importAccounts(visitPlanId, $scope.validRows)
            .pipe(finalize(() => {
              $scope.submitting = false;
              $scope.$applyAsync();
            }))
            .subscribe({
              next: (batch: AccountsImportBatchModel | null) => {
                if (!batch) {
                  $scope.noChanges = true;
                  $scope.progress = 100;
                  $scope.stage = 'success';
                  $scope.$applyAsync();
                  return;
                }

                startPolling(batch);
              },
              error: (error) => setFailureFromError(error, 'VISIT_PLAN_ACCOUNT_IMPORT.IMPORT_ERROR')
            });
        };

        // Stops the progress polling before the dialog goes away.
        $scope.$on('$destroy', () => poller?.cancel());

        $scope.cancel = () => {
          poller?.cancel();
          self.$mdDialog.cancel();
        };

        $scope.close = () => {
          poller?.cancel();

          return self.$mdDialog.hide({
            imported: !$scope.noChanges
              && ($scope.stage === 'success' || $scope.stage === 'importing' || $scope.createdCount > 0),
            createdCount: $scope.createdCount
          });
        };
      }
    });
  }

  importVisitScheduleAgents(
    visitPlanId: string,
    visitScheduleId: string,
    scheduleStatus?: VisitScheduleStatusEnum,
    event?: Event
  ) {
    const self = this;

    return this.$mdDialog.show({
      multiple: true,
      clickOutsideToClose: false,
      escapeToClose: false,
      parent: angular.element(document.body),
      targetEvent: event,
      template: require('../views/import-visit-schedule-agents-dialog.html').default,
      controller: function ($scope, pollingIntervalService: PollingIntervalService) {
        const MAX_POLL_ATTEMPTS = 120;

        let poller: PollingIntervalRef;
        let batchId: string;
        let pollingInFlight = false;
        let pollingErrors = 0;
        let pollAttempts = 0;

        $scope.stage = 'upload';
        $scope.file = null;
        $scope.importResult = null;
        $scope.validRows = [];
        $scope.invalidRows = [];
        $scope.validating = false;
        $scope.submitting = false;
        $scope.canImport = false;
        $scope.requestError = null;
        $scope.requestErrorKey = null;
        $scope.progress = 0;
        $scope.completedCount = 0;
        $scope.createdCount = 0;
        $scope.failedCount = 0;
        $scope.totalCount = 0;
        $scope.noChanges = false;
        $scope.stillRunning = false;
        $scope.isOngoing = scheduleStatus !== VisitScheduleStatusEnum.Init;
        $scope.downloadUrl = visitScheduleAgentsImportSampleFileLink;
        $scope.downloadFileName = visitScheduleAgentsImportSampleFileName;

        const refreshCanImport = () => {
          $scope.canImport = $scope.isOngoing
            && !$scope.validating
            && !$scope.submitting
            && !!$scope.validRows.length
            && !$scope.invalidRows.length;
        };

        const getErrorKey = (error: any, fallbackKey: string): string => {
          const code = _.get(error, 'error.code') || _.get(error, 'code');
          const status = _.get(error, 'status');

          if (code === 400431) {
            return 'VISIT_SCHEDULE_AGENT_IMPORT.NOT_ONGOING_ERROR';
          }

          if (status === 403) {
            return 'VISIT_SCHEDULE_AGENT_IMPORT.PERMISSION_ERROR';
          }

          if (status === 404) {
            return 'VISIT_SCHEDULE_AGENT_IMPORT.NOT_FOUND_ERROR';
          }

          return fallbackKey;
        };

        // The server message is already localized, the view translates the key fallbacks.
        const setRequestError = (error: any, fallbackKey: string) => {
          const response = _.get(error, 'error');
          const message = typeof response === 'string'
            ? response
            : _.get(response, 'more_info')
              || _.get(response, 'message')
              || _.get(response, 'description')
              || _.get(error, 'more_info');

          $scope.requestError = message || null;
          $scope.requestErrorKey = message ? null : getErrorKey(error, fallbackKey);
        };

        const showFailure = () => {
          poller?.cancel();
          $scope.stage = 'failure';
          $scope.$applyAsync();
        };

        const setFailure = (message?: string) => {
          $scope.requestError = message || null;
          $scope.requestErrorKey = null;
          showFailure();
        };

        const setFailureFromError = (error: any, fallbackKey: string) => {
          setRequestError(error, fallbackKey);
          showFailure();
        };

        const updateProgress = (status: AgentsImportStatusModel) => {
          const totals = status?.totals;
          const batchStatus = status?.batch?.details?.status;
          const processed = (totals?.completed || 0) + (totals?.failed || 0) + (totals?.timeOut || 0);

          $scope.totalCount = totals?.total || $scope.totalCount || 0;
          $scope.createdCount = totals?.completed || 0;
          $scope.failedCount = (totals?.failed || 0) + (totals?.timeOut || 0);
          $scope.completedCount = processed;
          $scope.progress = $scope.totalCount
            ? Math.min(100, $scope.completedCount / $scope.totalCount * 100)
            : (status?.batch?.details?.progress || 0);

          if (batchStatus === AgentsImportBatchStatusEnum.CompletedWithErrors) {
            setFailure();
            return;
          }

          if (batchStatus === AgentsImportBatchStatusEnum.Completed) {
            poller?.cancel();
            $scope.createdCount = $scope.createdCount || $scope.totalCount;
            $scope.progress = 100;
            $scope.stage = $scope.failedCount ? 'failure' : 'success';
          }

          $scope.$applyAsync();
        };

        const pollStatus = () => {
          if (pollingInFlight || $scope.stage !== 'importing' || !batchId) {
            return;
          }

          if (++pollAttempts > MAX_POLL_ATTEMPTS) {
            poller?.cancel();
            $scope.stillRunning = true;
            $scope.$applyAsync();
            return;
          }

          pollingInFlight = true;
          self.visitPlanHttpService.getAgentsImportStatus(visitPlanId, visitScheduleId, batchId)
            .pipe(finalize(() => pollingInFlight = false))
            .subscribe({
              next: (status: AgentsImportStatusModel) => {
                pollingErrors = 0;
                updateProgress(status);
              },
              error: (error) => {
                pollingErrors++;
                if (pollingErrors >= 3) {
                  setFailureFromError(error, 'VISIT_SCHEDULE_AGENT_IMPORT.PROGRESS_ERROR');
                }
              }
            });
        };

        const startPolling = (batch: AgentsImportBatchModel) => {
          batchId = batch.id;
          $scope.totalCount = batch.details?.total || $scope.validRows.length;
          $scope.completedCount = batch.details?.completed || 0;
          $scope.failedCount = batch.details?.failed || 0;
          $scope.progress = $scope.totalCount
            ? Math.min(100, $scope.completedCount / $scope.totalCount * 100)
            : (batch.details?.progress || 0);

          pollStatus();
          poller = pollingIntervalService.start($scope, pollStatus, 2500);
        };

        $scope.onFileChanged = (file: File) => {
          $scope.file = file;
          $scope.importResult = null;
          $scope.validRows = [];
          $scope.invalidRows = [];
          $scope.requestError = null;
          $scope.requestErrorKey = null;
          $scope.stage = 'upload';
          refreshCanImport();

          if (!file) {
            return;
          }

          $scope.validating = true;
          refreshCanImport();
          self.visitPlanHttpService.validateAgentsImport(file, visitPlanId, visitScheduleId)
            .pipe(finalize(() => {
              $scope.validating = false;
              refreshCanImport();
              $scope.$applyAsync();
            }))
            .subscribe({
              next: (rows: AgentsImportValidateRowModel[]) => {
                $scope.importResult = rows || [];
                $scope.validRows = _.filter($scope.importResult, row => !row.mappingErrors?.length);
                $scope.invalidRows = _.filter($scope.importResult, row => !!row.mappingErrors?.length);
                $scope.stage = 'preview';
                refreshCanImport();
                $scope.$applyAsync();
              },
              error: (error) => {
                $scope.file = null;
                setRequestError(error, 'VISIT_SCHEDULE_AGENT_IMPORT.VALIDATION_ERROR');
                $scope.$applyAsync();
              }
            });
        };

        $scope.submit = () => {
          if (!$scope.canImport) {
            return;
          }

          $scope.submitting = true;
          $scope.stage = 'importing';
          $scope.requestError = null;
          $scope.requestErrorKey = null;
          $scope.totalCount = $scope.validRows.length;
          refreshCanImport();

          // Send the validate payload unchanged — the server re-resolves and rejects edits.
          self.visitPlanHttpService.importAgents(visitPlanId, visitScheduleId, $scope.importResult)
            .pipe(finalize(() => {
              $scope.submitting = false;
              $scope.$applyAsync();
            }))
            .subscribe({
              next: (batch: AgentsImportBatchModel) => {
                if (!batch?.id) {
                  $scope.noChanges = true;
                  $scope.progress = 100;
                  $scope.stage = 'success';
                  $scope.$applyAsync();
                  return;
                }

                startPolling(batch);
              },
              error: (error) => setFailureFromError(error, 'VISIT_SCHEDULE_AGENT_IMPORT.IMPORT_ERROR')
            });
        };

        // Stops the progress polling before the dialog goes away.
        $scope.$on('$destroy', () => poller?.cancel());

        $scope.cancel = () => {
          poller?.cancel();
          self.$mdDialog.cancel();
        };

        $scope.close = () => {
          poller?.cancel();

          return self.$mdDialog.hide({
            imported: !$scope.noChanges
              && ($scope.stage === 'success' || $scope.stage === 'importing' || $scope.createdCount > 0),
            createdCount: $scope.createdCount
          });
        };
      }
    });
  }

  importDeliveryDays(visitPlanId: string, deliveriesCount: number = 0, servicesCount: number = 0) {
    const self = this;
    return this.$mdDialog.show({
      multiple: true,
      clickOutsideToClose: true,
      parent: angular.element(document.body),
      template: require('../views/import-deliveries-services-dialog.html').default,
      controller: function ($scope, $timeout, schedulingProjectAlertsService) {
        $scope.importDeliveriesMode = 'None';
        $scope.file = null;
        $scope.errors = [];
        $scope.importResult = null;
        $scope.deliveriesCount = deliveriesCount;
        $scope.servicesCount = servicesCount;

        $scope.onFileChanged = (file) => {
          $scope.file = file;
          $scope.errors = [];

          if ($scope.file && $scope.importDeliveriesMode === 'File') {
            self.visitPlanHttpService.importDeliveryDaysValidate(file, visitPlanId).subscribe(data => {
              $scope.importResult = data;
              $scope.errors = _.flatMap($scope.importResult, 'mappingErrors');
              $timeout(() => {}, 0);
            });
          }

          $timeout(() => {}, 0);
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          if ($scope.importDeliveriesMode === 'File' && $scope.importResult && $scope.importResult.length) {
            self.visitPlanHttpService.importDeliveryDaysFromFile(visitPlanId, $scope.importResult).subscribe(data => {
              schedulingProjectAlertsService.updateVisitPlanSuccess();
            }, (error) => {
              schedulingProjectAlertsService.updateVisitPlanError();
            });
          } else if ($scope.importDeliveriesMode === 'System') {
            self.visitPlanHttpService.importDeliveryDaysFromSystem(visitPlanId).subscribe(data => {
              schedulingProjectAlertsService.updateVisitPlanSuccess();
            }, (error) => {
              schedulingProjectAlertsService.updateVisitPlanError();
            });
          }

          self.$mdDialog.hide();
        };
      },
    });
  }

  openAccountInfoDialog(account: AccountModel,
                        preferred: {agents: AccountPreferredAgent[], shouldRedirectToRanking: boolean},
                        dedicated: {agents: AccountPreferredAgent[], shouldRedirectToRanking: boolean},
                        restricted: {agents: AccountPreferredAgent[], shouldRedirectToRanking: boolean},
                        event?: any) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/visit-plan-account-info-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: false,
      controller: function ($scope) {
        $scope.account = account;
        $scope.preferred = preferred;
        $scope.dedicated = dedicated;
        $scope.restricted = restricted;
        $scope.accountName = account.name || 'Account Info';
        $scope.cancel = () => {
          self.$mdDialog.cancel();
        };
      }
    });
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .service('schedulingProjectDialogService', SchedulingProjectDialogService);

